import type { BaseItemSchema } from "@memorang/types";

// TODO: replace with structured extractor once SaaS PA workflow consumes typed
// content slots. For now pass full CMS item JSON so listening/multimodal task
// types (SSTL, DISW, RLSW, etc.) carry transcripts + media URLs through.
export const extractItemContent = (item: BaseItemSchema): string => {
	try {
		return JSON.stringify(item);
	} catch {
		return "";
	}
};
